import { SB } from '@play-co/replicant';

// Can be used only for current user, other user should not see any of this data
// Any features that shows players profiles to other players should use public profile only!!
// This will be filed automatically from platform data
const privateProfileSchema = SB.object({
  name: SB.string().optional(),
  photo: SB.string().optional(),
}).optional();

// This information provided by player we can use it for multiplayer features
// Each feature that want to use this public profile should set consent flag before usage this data
const publicProfileSchema = SB.object({
  // User provided name
  name: SB.string().optional(),
  // User provided photo
  photo: SB.string().optional(),
}).optional();

export type PublicProfile = SB.ExtractType<typeof publicProfileSchema>;

export const profileState = {
  // User photo and name for internal usage only, not for multiplayer
  profile: privateProfileSchema,
  // User photo and name can be used for multiplexer features but you should check consent flag first
  publicProfile: publicProfileSchema,
};
